import angular from 'angular';
import DateSelectorComponent from './date-selector.component';

const dateSelector = angular
	.module('dateSelector', [])
	.component('dateSelector', DateSelectorComponent)
	.name;

export default dateSelector;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/date-selector/date-selector.module.js